import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import style from './menu.module.css';

function Menu({ setmenu }) {
    return <div className={style.Menu}>
        <div className='fixed flex flex-col p-4 text-xl bg-white'>
            <AiOutlineClose onClick={() => setmenu(false)} />
            <div className='flex flex-col gap-4 p-12 text-[#1A3168]'>
                <a href="#">LIVE CLASSES</a>
                <a href="#"> ASSIGNMENTS</a>
                <a href="#">MY LEARNING</a>
                <a href="/courses">BUY COURSES</a>
                <a href="#">DIY COURSE</a>
                <a href="/home">DASHBOARD</a>
            </div>
        </div>
    </div>;
}

export default Menu;
